import { Row, Form, Col, Button, Switch, Modal, Tooltip } from 'antd';
import React, { ReactElement, useEffect, useState, useRef } from 'react';
import {
  CONFIGURE_EMAIL_FORM_KEYS,
  CONFIG_EMAIL_ERROR, GUTTOR_SPACE, KEYS_TO_HANDLE, PAYER_EMAIL_PLACEHOLDER, PRE_AUTH_EMAIL_CONFIG_TITLE,
  SETTLEMENT_EMAIL_CONFIG_TITLE, SETTLEMENT_EMAIL_INFO, TRIM_SPACE_REGEX, USER_PRE_AUTH_EMAIL_CONFIG, USER_SETTLEMENT_EMAIL_CONFIG,
} from '../../../shared/constants/commonConstants';
import { FormTextInput } from '../../../shared/components/crmFormElement/FormInput';
import FormInputPassword from '../../../shared/components/crmFormElement/FormInputPassword/FormInputPassword';
import { centeredNotification, isSuperAdmin, validateEmails } from '../../../utils/utility';
import { ReactComponent as ArrowUp } from '../../../assets/images/svg/icon_arrow_up.svg';
import { ReactComponent as PortalConfiguration } from '../../../assets/images/svg/portal-configured.svg';
import { ReactComponent as EmailConfiguration } from '../../../assets/images/svg/email-icon.svg';
import { ReactComponent as ArrowDown } from '../../../assets/images/svg/icon_arrow_down.svg';
import { ReactComponent as InfoIcon } from '../../../assets/images/svg/information-icon_fill.svg';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchLatestHospitalMailData, fetchPayerConfig, savePayerEmailConfig,
  savePayerEnableToggleConfig, setEnabledPayer, verifyAndSavePortalCredentials,
} from '../../../store/actions/mailBoxAction';
import ApplicationDetail from '../../../shared/services/applicationDetail.service';
import { ReactComponent as EditIcon } from '../../../assets/images/svg/Edit-icon.svg';
import SuccessModal from '../../../shared/components/modal/SuccessModal';
import { refreshInternalData } from '../../../store/actions/utilAction';
import { MailboxType } from '../../../store/models/mailBoxModel';
import { RootState } from '../../../store';
import { useHistory } from 'react-router-dom';
import { customGTMEvent } from '../../crm/inPatient/service/crmUtils';
import { EmailConfigurationSection } from './ConfigureEmail';
import { isEmpty } from 'lodash';

const PayerConfig = ({ payerDetails }: any): ReactElement => {
  const [configureEmailForm] = Form.useForm();
  const [configurePortalForm] = Form.useForm();
  const [payer, setPayer] = useState(payerDetails as any);
  const [isDetailsVisible, setIsDetailsVisible] = useState(false);
  const [showConfigurePayer, setShowConfigurePayer] = useState(false);
  const [verifyingCreds, setVerifyingCreds] = useState(false);
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
  const [payerPreAuthEmails, setPayerPreAuthEmails] = useState([] as any);
  const [payerSettlementEmails, setSettlementPayerEmails] = useState([] as any);
  const [highlightField, setHighlightField] = useState(false);
  const appDetail = ApplicationDetail.instance;
  const dispatch = useDispatch();
  const history = useHistory();
  const groupProviders = appDetail?.getGroupProviders();
  const { hospitalConfiguration: emailConfig = {} as any, enabledPayer, centerId } =
    useSelector((state: RootState): MailboxType => state?.mailBox || {});
  const payerRef = useRef<{ [key: string]: HTMLDivElement }>({});

  useEffect((): any => {
    if (enabledPayer && payerRef?.current[enabledPayer]) {
      setIsDetailsVisible(!isDetailsVisible);
      setTimeout(scrollToBottom, 100);
    }
  }, [history.location.pathname, enabledPayer]);

    // onchange of center the scroll and then panel should not be visible
    useEffect((): any => {
      if (centerId && !enabledPayer) {
        setIsDetailsVisible(false);
      }
    }, [centerId]);

    useEffect((): any => {
      setPayer(payerDetails);
    }, [payerDetails]);

  useEffect((): any => {
    setInitialPayerEmail();
    setPayerPortalCredentials();
    setShowConfigurePayer(payer?.credentials?.length > 0);
  }, [payer]);

  useEffect((): any => {
    setShowConfigurePayer(payer?.credentials?.length > 0);
  }, [isDetailsVisible]);

  const setInitialPayerEmail = (): any => {
    setPayerPreAuthEmails(payer?.payerEmailID?.split(',') || []);
    setSettlementPayerEmails(payer?.payerEmailIdForClaim?.split(',') || []);
  };

  const setPayerPortalCredentials = (): any => {
    configurePortalForm?.resetFields();
    payer?.credentials?.forEach((credential: any, index: number): any => {
      configurePortalForm.setFieldsValue({
        [`configure-portal-username-${index}`]: credential?.userName,
        [`configure-portal-password-${index}`]: credential?.password,
      });
    });
  };

  const onToggleDetails = (): any => {
    setIsDetailsVisible(!isDetailsVisible);
    setInitialPayerEmail();
    setPayerPortalCredentials();
    configureEmailForm?.resetFields();
    customGTMEvent({
      event: 'Click on Configure',
    });
  };

  const isGroupProvidersAvailable = (): boolean => {
    return !!groupProviders?.length && !centerId;
  };

  const getCredentialFields = (payerCreds: any): any => {
    const credentialFields: JSX.Element[] = [];
    for (let i = 0; i < payer?.requiredCredentialsCount; i++) {
      credentialFields?.push(
        <Row gutter={GUTTOR_SPACE} className="flex flex-row align-baseline">
          <Col md={6}>
            <FormTextInput detail={{
              key: `configure-portal-username-${i}`,
              placeholder: 'Enter username',
              hideLabel: true,
              disabled: showConfigurePayer,
              className: `payerCredential-input ${highlightField ? 'form-bordered-success' : ''}`,
              maxLength: true,
              required: true,
              label: 'Username',
            }}
            />
          </Col>
          <Col md={6}>
            <FormInputPassword detail={{
              key: `configure-portal-password-${i}`,
              placeholder: 'Enter password',
              hideLabel: true,
              disabled: showConfigurePayer,
              className: `payerCredential-input ${highlightField ? 'form-bordered-success' : ''}`,
              maxLength: true,
              required: true,
              label: 'Password',
            }}
            />
          </Col>
          {
            i === payer?.requiredCredentialsCount - 1 &&
            <>
              {showConfigurePayer ?
                <Col className="padding-top-19">
                  <EditIcon
                    className="email-editbtn-primary"
                    onClick={(): any => {
                      setShowConfigurePayer(false);
                      setHighlightField(false);
                      customGTMEvent({
                        event: 'Configure Portal',
                      });
                    }} />
                </Col> :
                <><Col md={1} className="pb-md">
                  <a onClick={(): any => onSaveCredentials()} className="mouse-pointer bold">SAVE</a>
                </Col><Col onClick={(): any => {
                  setPayerPortalCredentials();
                  setShowConfigurePayer(payer?.credentials?.length > 0); setHighlightField(false);
                }}
                  md={1} className="pb-md bold color-grey mouse-pointer">
                    <div>CANCEL</div>
                  </Col></>
              }
            </>
          }
        </Row>);
    }
    return credentialFields;
  };

  const toggleCheck = (payerValue: any, isRemovedEmail: any, emailArray: any): any => {
    if (!payerValue?.isPortalCredentialMandatory) {
      return !isRemovedEmail && emailArray?.length === 1;
    } else {
      return (payerValue?.credentials?.length === 1 && !isRemovedEmail && emailArray?.length === 1) ||
        (payerValue?.credentials?.length !== 0 && emailArray?.length === 0) || payerValue?.isEnabled;
    }
  };

  const onSucessPayerEmailConfg = (updatedPayer: any, preAuthEmails: string, settlementEmails: string, fieldKey: string): void => {
    setPayer(updatedPayer);
    configureEmailForm?.resetFields([fieldKey]);
    dispatch(fetchPayerConfig(appDetail?.getProviderId()));
    setPayerPreAuthEmails(!isEmpty(preAuthEmails) ? preAuthEmails?.split(',') : []);
    setSettlementPayerEmails(!isEmpty(settlementEmails) ? settlementEmails?.split(',') : []);
    dispatch(refreshInternalData(!(groupProviders && groupProviders?.length), false, false, false, isSuperAdmin()));
  };
  const emailChangeApiCall = (preAuthEmails: string, settlementEmails: string, fieldKey: string, isRemovedEmail?: boolean): any => {
    const preAuthEmailArray = preAuthEmails?.split(TRIM_SPACE_REGEX)?.filter((email: string): boolean => email?.trim() !== '');
    const payload = {
      providerId: appDetail.getProviderId(),
      payerId: payer.payerID,
      payerEmailId: preAuthEmails,
      payerEmailIdForClaim: settlementEmails,
    };
    const updatedPayer = {
      ...payer, payerEmailID: preAuthEmails, payerEmailIdForClaim: settlementEmails, isEnabled:
        (isRemovedEmail && !preAuthEmailArray?.length) ? false : (toggleCheck(payer, isRemovedEmail, preAuthEmailArray)
          || payer?.isEnabled),
    };
    dispatch(savePayerEmailConfig(payload, onSucessPayerEmailConfg(updatedPayer, preAuthEmails, settlementEmails, fieldKey),
      (errors: any): any => { centeredNotification(errors); }));
  };

  const onSavePayerEmail = async (fieldKey: string, payerEmails: string[], isPreAuthEmail: boolean): Promise<void> => {
    try {
      const emailFormObj = await configureEmailForm?.validateFields([fieldKey]);
      let emails = validateEmails(emailFormObj?.[fieldKey], payerEmails);
      if (!isEmpty(emails)) {
        if (!isEmpty(payerEmails)) {
          emails = emails?.concat(',', payerEmails?.toString());
        }
        // Remove the trailing comma, if present at the end
        const emailString: string = emails?.replace(/,$/, '');
        emailChangeApiCall(
          isPreAuthEmail ? emailString : payerPreAuthEmails?.toString(),
          !isPreAuthEmail ? emailString : payerSettlementEmails?.toString(),
          fieldKey,
        );
      }
      customGTMEvent({
        event: 'Configure Email',
      });
    } catch (error) {
      console.error(CONFIG_EMAIL_ERROR, error);
    }
  };

  const onEmailRemove = (removedEmail: any, isPreAuth: boolean, fieldKey: string): any => {
    const finalPreAuthEmails = isPreAuth ? payerPreAuthEmails?.filter((email: any): boolean => email !== removedEmail) :
      payerPreAuthEmails || [];
    const finalSettlementEmails = !isPreAuth ? payerSettlementEmails?.filter((email: any): boolean => email !== removedEmail) :
      payerSettlementEmails || [];
    emailChangeApiCall(finalPreAuthEmails?.toString(), finalSettlementEmails.toString(), fieldKey, true);
  };

  const VerifyCredentials = (credVerificationStatus: any, updatedCredentials: any): any => {
    let allVerified = true;
    const allFormValues = Object?.keys(configurePortalForm?.getFieldsValue());
    credVerificationStatus?.forEach((cred: any): any => {
      const fieldKey = allFormValues?.find((key: any): any => configurePortalForm?.getFieldsValue()[key] === cred.userName);
      const index = fieldKey?.replace('configure-portal-username-', '');
      if (credVerificationStatus !== null && !cred.isVerified) {
        configurePortalForm.setFields([
          {
            name: `configure-portal-username-${index}` as any,
            errors: ['Invalid credentials'],
          },
          {
            name: `configure-portal-password-${index}` as any,
            errors: [''],
          },
        ]);
        allVerified = false;
      } else {
        setHighlightField(true);
        }
    });
    setVerifyingCreds(false);
    if (credVerificationStatus !== null && allVerified) {
      const updatedPayer = { ...payer, credentials: updatedCredentials };
      setIsSuccessModalVisible(true);
      setShowConfigurePayer(true);
      setPayer(updatedPayer);
      if (updatedCredentials) {
        const payload = {
          username: updatedCredentials?.[0]?.userName,
          password: updatedCredentials?.[0]?.password,
          payerId: payer?.payerID,
          providerId: appDetail?.getProviderId(),
          payerPortalLink: payer?.payerPortalLink,
        };
        dispatch(fetchLatestHospitalMailData(payload));
        dispatch(refreshInternalData(!(groupProviders && groupProviders?.length), false, false, false, isSuperAdmin()));
      }
    }
  };

  const onSaveCredentials = async (): Promise<void> => {
    const fieldValues = await configurePortalForm?.validateFields();
    const credentials = [] as any;
    const fieldValueKeys = Object?.keys(fieldValues);
    let isDuplicate = false;
    for (let i = 0; i < fieldValueKeys?.length / 2; i++) {
      const userName = fieldValues[`configure-portal-username-${i}`];
      const password = fieldValues[`configure-portal-password-${i}`];
      credentials.push({ userName, password });
      // Check for duplicates
      if (i > 0 && credentials?.some((cred: any, index: any): any => index < i && cred?.userName === userName)) {
        centeredNotification('Please enter unique credentials', 'error');
        isDuplicate = true;
        break;
      }
    }
    if (credentials?.length && !isDuplicate) {
      const payload = {
        providerId: appDetail.getProviderId(),
        payerId: payer.payerID,
        payerPortalLink: payer.payerPortalLink,
        payerCredentials: credentials,
      };
      setVerifyingCreds(true);
      dispatch(verifyAndSavePortalCredentials(payload, (credResponse: any): any => {
        VerifyCredentials(credResponse, credentials);
      }, (errors: any): any => { centeredNotification(errors); setVerifyingCreds(false); }));
    }
  };

  const toggleEnableSwitch = (event: any): any => {
    if (event && !payer?.payerEmailID) {
      centeredNotification('Please enter email to enable the payer', 'error');
    } else {
      const payload = {
        providerId: appDetail.getProviderId(),
        isEnabled: event,
        payerId: payer.payerID,
      };
      dispatch(savePayerEnableToggleConfig(payload, (): any => {
        const updatedPayer = { ...payer, isEnabled: event }; setPayer(updatedPayer);
        dispatch(refreshInternalData(!(groupProviders && groupProviders?.length), false, false, false, isSuperAdmin()));
      }));
    }
    customGTMEvent({
      event: event
      ? 'Payer toggle switched ON'
      : 'Payer toggle switched OFF',
    });
  };

  const onChangeToggle = (payerRecord: any): boolean => {
    const { isPortalCredentialMandatory, payerEmailID, credentials } = payerRecord;
    const hasValidEmail = (typeof payerEmailID === 'string' || payerEmailID === null) && !payerEmailID?.length;
    const hasCredentials = credentials?.length;
    if (isGroupProvidersAvailable()) {
      return true;
    }
    if (!emailConfig?.isEmailVerified || emailConfig?.passwordExpire) {
      return true;
    }
    if (isPortalCredentialMandatory && !hasValidEmail && !hasCredentials) {
      return true; // Return true if portal credentials are mandatory and email is invalid and no credentials
    }
    if (hasValidEmail) {
      return true; // Return true if email is valid
    }
    return false;
  };

  const getPayerTooltipTitle = (payerElement: any): string => {
    const { isPortalCredentialMandatory, payerEmailID, credentials } = payerElement;
    const isEmailPresent = (typeof payerEmailID === 'string' || payerEmailID === null) &&
      !payerEmailID?.length;
    if (isGroupProvidersAvailable()) {
      return '';
    }
    if (!emailConfig?.isEmailVerified) {
      return 'Please configure Hospital Email in Configure Hospital';
    }
    if (emailConfig?.passwordExpire) {
      return 'Please reconfigure your mailbox credentials in Configure Hospital';
    }
    if (isPortalCredentialMandatory) {
      if (!credentials?.length) {
        return 'Configure Portal';
      } else {
        if (isEmailPresent) {
          return 'Configure Email';
        }
      }
    }
    if (isEmailPresent) {
      return 'Configure Email';
    }
    return '';
  };

  const getPayerClassName = (payerItem: any): string => {
    const { isPortalCredentialMandatory, payerEmailID, credentials } = payerItem;
    const isPayerEmailPresent = (typeof payerEmailID === 'string' || payerEmailID === null) && !payerEmailID?.length;
    if (isGroupProvidersAvailable()) {
      return 'payer-name center-disabled-color';
    }
    if (!emailConfig?.isEmailVerified || emailConfig?.passwordExpire) {
      return 'payer-name disabled-color';
    }
    if (isPortalCredentialMandatory && !credentials?.length) {
      return 'payer-name disabled-color';
    }
    if (isPayerEmailPresent) {
      return 'payer-name disabled-color';
    }
    if (isDetailsVisible) {
      return 'payer-name ft-wt-700';
    }
    return 'payer-name';
  };

  const clearPreAuthEmail = (): void => {
    configureEmailForm?.resetFields([CONFIGURE_EMAIL_FORM_KEYS?.preAuthEmail]);
  };

  const clearSettlementEmail = (): void => {
    configureEmailForm?.resetFields([CONFIGURE_EMAIL_FORM_KEYS?.settlementEmail]);
  };

  const isGroupLogin = (): boolean => {
    if (groupProviders?.length && centerId) {
      return true;
    } else {
      return !groupProviders?.length; // Return true if it's not a group login, otherwise false
    }
  };

  const scrollToBottom = (): any => {
    const element = payerRef?.current[enabledPayer];
    if (element) {
      element?.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    }
    dispatch(setEnabledPayer(0));
  };
    const handleKeyEnter = (event: any, saveEmail: () => void): void => {
      if (event.key === KEYS_TO_HANDLE?.Enter) {
        saveEmail();
      }
    };

  return (
    <>
      <div key={payer?.payerID} ref={(el: any): any => payerRef.current[payer.payerID] = el} className="bg-color-white border-bottom">
        <div className="flex flex-element flex-row align-center justify-between w-100">
          <Row gutter={20} className="flex flex-element flex-row align-center justify-start gap-1 w-80">
            <Col className={getPayerClassName(payer)} md={10}>{payer.payerName}
            </Col>

            <Col md={2}>
              <Tooltip title={getPayerTooltipTitle(payer)}>
                <Switch
                  size="small"
                  className={(isGroupProvidersAvailable()) ? 'manage-config-group-login' : 'manage-config'}
                  checked={isGroupProvidersAvailable() ? false : payer?.isEnabled}
                  onChange={(e: any): any => toggleEnableSwitch(e)}
                  disabled={onChangeToggle(payer)}
                />
              </Tooltip>
            </Col>
          </Row>
          <Row gutter={4} onClick={onToggleDetails} className="flex flex-element flex-row align-center justify-end w-20">
            <Col className="flex flex-element flex-row align-center">
              {
                (!isDetailsVisible && isGroupLogin()) &&
                <>
                  {!payer?.payerEmailID ?
                    <Button type="link">Configure
                    </Button> :
                    <>
                      {((typeof payer?.payerEmailID === 'string' || payer?.payerEmailID !== null) && payer?.payerEmailID?.length) &&
                        <Button className="colorGreen pd-top" size="small" type="link"><Tooltip title="Email Configured" placement="bottom">
                          <EmailConfiguration /></Tooltip>
                        </Button>}
                      {(payer?.credentials?.length > 0) && <Button className="colorGreen" size="small" type="link">
                        <Tooltip title="Portal Configured" placement="bottom" ><PortalConfiguration /></Tooltip>
                      </Button>}
                    </>
                  }
                </>
              }
            </Col>
            <Col className="flex flex-element flex-row align-center mouse-pointer">
              {
                isGroupLogin() ? isDetailsVisible ?
                  <ArrowUp /> : <ArrowDown /> : <></>
              }
            </Col>
          </Row>
        </div>
        {isDetailsVisible && (
          <>
            <div className="mailbox-config-container">
              {(payer?.isPortalCredentialMandatory && (!payer?.payerEmailID || payer?.credentials?.length === 0)) &&
                <div className="font-12 credentialMandatoryText">
                  <p>Please configure portal and Email to enable {payer?.payerName}</p>
                </div>}
              <div>
                <div className="p-14">
                  <Form form={configureEmailForm} className="flex-element flex-col gap-5">
                    <EmailConfigurationSection
                      title={PRE_AUTH_EMAIL_CONFIG_TITLE}
                      placeholder={PAYER_EMAIL_PLACEHOLDER}
                      description={USER_PRE_AUTH_EMAIL_CONFIG}
                      emailKey= {CONFIGURE_EMAIL_FORM_KEYS?.preAuthEmail}
                      emails={payerPreAuthEmails}
                      payerObj={payer}
                      onSave={(): Promise<void> => onSavePayerEmail(CONFIGURE_EMAIL_FORM_KEYS?.preAuthEmail, payerPreAuthEmails, true)}
                      onRemove={(email: string): any => onEmailRemove(email, true, CONFIGURE_EMAIL_FORM_KEYS?.preAuthEmail)}
                      handleKey={(event: React.KeyboardEvent<HTMLInputElement>): any => handleKeyEnter(event,
                        (): Promise<void> => onSavePayerEmail(CONFIGURE_EMAIL_FORM_KEYS?.preAuthEmail, payerPreAuthEmails, true))}
                      clearEmailField={(): void => clearPreAuthEmail()}

                    />
                    <EmailConfigurationSection
                      title={SETTLEMENT_EMAIL_CONFIG_TITLE}
                      placeholder={PAYER_EMAIL_PLACEHOLDER}
                      description={USER_SETTLEMENT_EMAIL_CONFIG}
                      emailKey= {CONFIGURE_EMAIL_FORM_KEYS?.settlementEmail}
                      emails={payerSettlementEmails}
                      payerObj={payer}
                      onSave={(): Promise<void> => onSavePayerEmail(CONFIGURE_EMAIL_FORM_KEYS?.settlementEmail,
                         payerSettlementEmails, false)}
                      onRemove={(email: string): any => onEmailRemove(email, false, CONFIGURE_EMAIL_FORM_KEYS?.settlementEmail)}
                      handleKey={(event: React.KeyboardEvent<HTMLInputElement>): any => handleKeyEnter(event,
                        (): Promise<void> => onSavePayerEmail(CONFIGURE_EMAIL_FORM_KEYS?.settlementEmail, payerSettlementEmails, false))}
                      clearEmailField={(): void => clearSettlementEmail()}
                    />
                    <Row gutter={GUTTOR_SPACE} className="information-row">
                      <Col md={1} className="information-icon">
                        <InfoIcon />
                      </Col>
                      <Col md={23} className="information-text">
                        {SETTLEMENT_EMAIL_INFO}
                      </Col>
                    </Row>
                  </Form>
                </div>
                {payer?.requiredCredentialsCount > 0 && <div className="p-14">
                  <Row className={!payerPreAuthEmails ? 'pd-t-17' : 'pd-t-11'}>
                    <Col className="m-10 font-12 font-weight-text">
                      <div>Configure Portal</div>
                    </Col>
                  </Row>
                  <p className="p-14 font-12">Ensure all the Portal details are filled in correctly.</p>
                  <Form form={configurePortalForm} className="flex-element flex-col gap-5" onFinish={onSaveCredentials}>
                    {getCredentialFields(payer)}
                  </Form>
                </div>}
              </div>
            </div>
          </>
        )}
      </div>
      {
        isSuccessModalVisible &&
        <SuccessModal isVisible={isSuccessModalVisible} setIsVisible={setIsSuccessModalVisible} successModalText="Saved Successfully"/>
      }
      {
        verifyingCreds &&
        <Modal
          visible={verifyingCreds}
          footer={null}
          closable={false}
          maskClosable={false}
          className="flex flex-element justify-center items-center verifying-creds-modal h-50"
          onCancel={(): any => setVerifyingCreds(false)}>
          <div className="flex flex-element flex-col justify-center items-center p-sm h-100">
            <div className="mb-sm verifyingCreds" />
            <div className="mb-sm ">
              Verifying
            </div>
          </div>
        </Modal>
      }
    </>
  );
};

export default PayerConfig;
